import { c as _c } from "react/compiler-runtime";
import { Skeleton } from '@systemeio/components';
import React from 'react';
const UserSettingsSkeleton = () => {
  const $ = _c(5);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="h-[64px] p-5"><Skeleton className="rounded-sm text-transparent">.</Skeleton></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  let t1;
  if ($[1] === Symbol.for("react.memo_cache_sentinel")) {
    t1 = <div className="desktop:h-[66px] desktop:flex-row desktop:gap-10 flex flex-col justify-between gap-7 [&>*]:flex-1"><Skeleton className="desktop:py-0 my-3 rounded-sm py-2.5 text-transparent">.</Skeleton><Skeleton className="desktop:py-0 my-3 rounded-sm py-2.5 text-transparent">.</Skeleton><Skeleton className="desktop:py-0 my-3 rounded-sm py-2.5 text-transparent">.</Skeleton></div>;
    $[1] = t1;
  } else {
    t1 = $[1];
  }
  let t2;
  if ($[2] === Symbol.for("react.memo_cache_sentinel")) {
    t2 = <div className="desktop:h-[66px] desktop:flex-row desktop:gap-10 flex flex-col justify-between gap-7 [&>*]:flex-1"><Skeleton className="desktop:py-0 my-3 rounded-sm py-2.5 text-transparent">.</Skeleton><Skeleton className="desktop:py-0 my-3 rounded-sm py-2.5 text-transparent">.</Skeleton><Skeleton className="desktop:py-0 my-3 rounded-sm py-2.5 text-transparent">.</Skeleton></div>;
    $[2] = t2;
  } else {
    t2 = $[2];
  }
  let t3;
  if ($[3] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = <div className="desktop:h-[66px] desktop:flex-row desktop:gap-10 flex flex-col justify-between gap-7 [&>*]:flex-1"><Skeleton className="desktop:py-0 my-3 rounded-sm py-2.5 text-transparent">.</Skeleton><Skeleton className="desktop:py-0 my-3 rounded-sm py-2.5 text-transparent">.</Skeleton><Skeleton className="desktop:py-0 my-3 rounded-sm py-2.5 text-transparent">.</Skeleton></div>;
    $[3] = t3;
  } else {
    t3 = $[3];
  }
  let t4;
  if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="bg-bg-primary border-border-100 flex h-fit w-full flex-col gap-5 overflow-x-hidden rounded-md border">{t0}<div className="desktop:gap-10 flex animate-pulse flex-col gap-7 px-5 pb-5">{t1}{t2}{t3}<div className="desktop:h-[44px] desktop:flex-row desktop:gap-10 flex flex-col justify-between gap-7 [&>*]:flex-1"><Skeleton className="desktop:py-0 my-2 rounded-sm py-1 text-transparent">.</Skeleton></div></div></div>;
    $[4] = t4;
  } else {
    t4 = $[4];
  }
  return t4;
};
export default UserSettingsSkeleton;